import * as types from "./mutation-types";

export default {
  [types.SET_MESSAGE](state, payload) {
    state.message = payload;
  },
};
